export default "__VITE_PUBLIC_ASSET__9ec99086__"